import React from 'react';
import P from 'prop-types';
import './styles.css';
import IntlCurrencyInput from 'react-intl-currency-input';

export const InputText = ({
  type = '',
  className = '',
  placeHolder = '',
  name = '',
  onChange,
  value = '',
  textAlign = 'left',
  disabled = false,
  defaultChecked = '',
  fontSize = '20px',
  maxLength = null,
}) => {
  const currencyConfig = {
    locale: 'pt-BR',
    formats: {
      number: {
        BRL: {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  return (
    <>
      {type === 'currency' && (
        <IntlCurrencyInput
          style={{ textAlign: textAlign }}
          currency="BRL"
          value={value}
          autoFocus={true}
          onChange={onChange}
          className={className}
          config={currencyConfig}
          placeholder={placeHolder}
          disabled={disabled}
        />
      )}
      {type === 'radio' && (
        <input
          type="radio"
          name={name}
          className={className}
          disabled={disabled}
          onChange={onChange}
          value={value}
          defaultChecked={defaultChecked}
          style={{ textAlign: textAlign }}
        />
      )}
      {type === 'textarea' && (
        <textarea
          className={className}
          rows="4"
          disabled={disabled}
          placeholder={placeHolder}
          onChange={onChange}
          value={value}
          style={{ textAlign: textAlign, marginTop: '5px' }}
        />
      )}
      {type === 'text' && (
        <input
          name={name}
          className={className}
          placeholder={placeHolder}
          onChange={onChange}
          disabled={disabled}
          maxLength={maxLength}
          value={value}
          style={{
            textAlign: textAlign,
            backgroundColor: disabled ? '#ebebeb' : 'white',
            marginTop: '5px',
            fontSize: fontSize,
          }}
        />
      )}
      {type === 'password' && (
        <input
          type={'password'}
          name={name}
          className={className}
          placeholder={placeHolder}
          disabled={disabled}
          onChange={onChange}
          value={value}
          style={{ textAlign: textAlign, marginTop: '5px' }}
        />
      )}
      {type === 'date' && (
        <input
          type="date"
          name={name}
          className={className}
          onChange={onChange}
          disabled={disabled}
          value={value}
          style={{ textAlign: textAlign, marginTop: '5px' }}
        />
      )}
      {type === 'tel' && (
        <input
          type="tel"
          name={name}
          className={className}
          onChange={onChange}
          disabled={disabled}
          value={value}
          style={{ textAlign: textAlign, marginTop: '5px' }}
          placeholder="XXXX XXXX XXXX XXXX"
          pattern="\(\d{3}\) \d{3}\-\d{4}"
        />
      )}
      {type === 'submit' && (
        <input
          type="submit"
          value={value}
          name={name}
          className={`${disabled ? className + ' btnDisabled' : className}`}
          disabled={disabled}
        />
      )}
      {type === 'checkbox' && (
        <input
          type="checkbox"
          value={value}
          name={name}
          className={`${disabled ? className + ' btnDisabled' : className}`}
          disabled={disabled}
        />
      )}
    </>
  );
};

//placeholder="XXXX XXXX XXXX XXXX" pattern="\d{4} \d{4} \d{4} \d{4}"
InputText.propTypes = {
  type: P.string.isRequired,
  className: P.string,
  placeHolder: P.string,
  name: P.string,
  onChange: P.func,
  value: P.oneOfType([P.string, P.number]),
  textAlign: P.string,
  disabled: P.bool,
  defaultChecked: P.string,
  maxLength: P.number,
  fontSize: P.string,
};
